<template>
    <div>
        <div v-if="data.imagem" class="unifran-mobile">
            <div class="d-flex justify-content-center align-items-center height-498 background-image text-white font-glacial-bold font-120" :style="`background-image: url(${data.imagem.url}); background-position: center;`">
                <h2 class="text-upper-case text-white font-glacial-bold font-120">
                    {{data.nome}}
                </h2>
            </div>
        </div>
        <div v-if="data.imagem_mobile" class="unifran-web">
            <div class="d-flex justify-content-center align-items-center mb-xl-5 height-498 background-image text-white font-glacial-bold font-120" :style="`background-image: url(${data.imagem_mobile.url}); background-position: center;`">
                <h2 class="text-upper-case text-white font-glacial-bold font-120">
                    {{data.nome}}
                </h2>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        data: null
    },

    methods:{
            searchDebounce: _.debounce(function() {
                this.page = 0
                this.loadMore()
            }, 200),

            loadMore(){
                this.page++

                this.loading = true

                var url = window.SETTINGS.API_BASE_PATH + "posts?_embed&categories=5&page="+this.page+"&per_page=7"

                if(this.text1 != ""){

                    url = url + "&search=" + this.text1

                }

                axios.get(url).then(response => {
                    this.total = response.headers["x-wp-total"]
                    
                    if(this.page != 1){
                        this.posts = [
                            ...this.posts,
                            ...response.data
                        ]
                    } else{
                        this.posts = response.data
                    }

                this.loading = false

                })
            }
        }
}
</script>




// WEBPACK FOOTER //
// src/components/widgets/header_pagina.vue